module.exports = __webpack_public_path__ + "/content/skins/chase/fav/chaselogo2015-300x204.jpg";